<!-- Notice fournie en anglais uniquement (non traduite) : lang="en" pour les lecteurs d'écran -->
<div class="privacy-notice-dialog" lang="en">
  <h2 mat-dialog-title class="privacy-notice-dialog__title">{{ 'footer.privacy_notice.title' | translate }}</h2>

  <mat-dialog-content class="privacy-notice-dialog__content">
    <p>{{ 'footer.privacy_notice.controller' | translate }}</p>
    <p>{{ 'footer.privacy_notice.usage' | translate }}</p>
    <p>{{ 'footer.privacy_notice.rights' | translate }}</p>
  </mat-dialog-content>

  <mat-dialog-actions class="privacy-notice-dialog__actions" align="end">
    <button mat-flat-button color="primary" mat-dialog-close>{{ 'footer.privacy_notice.close' | translate }}</button>
  </mat-dialog-actions>
</div>
